import { render } from "./manufacturer.vue?vue&type=template&id=108fe582&scoped=true&ts=true"
import script from "./manufacturer.vue?vue&type=script&lang=ts"
export * from "./manufacturer.vue?vue&type=script&lang=ts"

import "./manufacturer.vue?vue&type=style&index=0&id=108fe582&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108fe582"]])

export default __exports__